var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "el-breadcrumb",
        { attrs: { "separator-class": "el-icon-arrow-right" } },
        [
          _c("el-breadcrumb-item", [_vm._v("订单管理")]),
          _c("el-breadcrumb-item", { attrs: { to: { path: "/orderList" } } }, [
            _c(
              "span",
              { staticStyle: { color: "#666", "font-weight": "normal" } },
              [_vm._v("我的订单")]
            ),
          ]),
          _c(
            "el-breadcrumb-item",
            {
              attrs: {
                to: {
                  path: "/orderDetail",
                  query: {
                    orderId: this.$route.query.orderId,
                    orderStatus: this.$route.query.orderStatus,
                  },
                },
              },
            },
            [_vm._v("交易记录")]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "table" },
        [
          _c("p", [_vm._v("订单编号：")]),
          _c(
            "el-table",
            { staticStyle: { width: "100%" }, attrs: { data: _vm.tableData } },
            [
              _c("el-table-column", {
                attrs: { type: "index", label: "序号", width: "50px" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "payId",
                  label: "微信支付订单号",
                  "min-width": "100px",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "nickName", label: "付款人" },
              }),
              _c("el-table-column", {
                attrs: { prop: "payMoney", label: "支付金额" },
              }),
              _c("el-table-column", {
                attrs: { prop: "payStatus", label: "支付状态" },
              }),
              _c("el-table-column", {
                attrs: { label: "支付时间" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            " " + _vm._s(_vm.$moment(scope.row.createdTime))
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "payeeName", label: "收款人" },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }